export default __webpack_public_path__ + "static/media/longest_duration.9125378e.svg";